import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsRolesRoleEditRoute extends Route {
  model() {
    return this.modelFor('settings.roles.role');
  }
}

export default instrumentRoutePerformance(SettingsRolesRoleEditRoute);
